<svg id="nm-svg-element" #nmSvgElement></svg>
